// Fondo de manchas difuminadas en movimiento (estilos en app/motion.css).
// variant: "dark" (aurora sobre verde bosque), "light" (aurora suave sobre
// marfil) o "subtle" (paneles de admin). fixed: capa fija a la ventana.
export function Aurora({ variant = "light", fixed = false }) {
  return (
    <div className={`aurora aurora--${variant}${fixed ? " aurora--fixed" : ""}`} aria-hidden="true">
      <span className="aurora__blob aurora__blob--1" />
      <span className="aurora__blob aurora__blob--2" />
      <span className="aurora__blob aurora__blob--3" />
      {/* Grano en SVG en línea y no como imagen de fondo (una imagen de fondo
          que cubre la sección se convierte en el LCP). Se pinta con una tesela
          de 160 px repetida: el ruido sobre toda la sección lo calcula Safari
          con la CPU en cada pintado y atasca el scroll en iPhone. */}
      {variant === "dark" && (
        <svg className="aurora__grain" focusable="false"><rect width="100%" height="100%" fill="url(#mv-grain-tile)" /></svg>
      )}
    </div>
  );
}

// Ruido compartido por todos los granos (una vez por documento): filtro + tesela.
export function AuroraDefs() {
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true" focusable="false">
      <filter id="mv-grain" x="0" y="0" width="100%" height="100%">
        <feTurbulence type="fractalNoise" baseFrequency=".9" numOctaves="2" stitchTiles="stitch" />
      </filter>
      <pattern id="mv-grain-tile" width="160" height="160" patternUnits="userSpaceOnUse">
        <rect width="160" height="160" filter="url(#mv-grain)" />
      </pattern>
    </svg>
  );
}

// Sección con aurora detrás del contenido. En "dark" el texto pasa a marfil y
// .section-title/.section-sub/.kicker se adaptan solos.
// OJO: la sección aísla capas y es contenedor (container-type): nada con
// position:fixed dentro (visores, popups, barras), o quedaría atrapado en ella.
export default function AuroraSection({ as: Tag = "section", variant = "light", className = "", children, ...rest }) {
  return (
    <Tag className={`aurora-host aurora-host--${variant} ${className}`} {...rest}>
      <Aurora variant={variant} />
      {children}
    </Tag>
  );
}
